/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ChainBlockInfo,
    ChainBlockInfoFromJSON,
    ChainBlockInfoFromJSONTyped,
    ChainBlockInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface ChainProposedBlocksResponse
 */
export interface ChainProposedBlocksResponse {
    /**
     * 
     * @type {Array<ChainBlockInfo>}
     * @memberof ChainProposedBlocksResponse
     */
    list: Array<ChainBlockInfo>;
    /**
     * 
     * @type {number}
     * @memberof ChainProposedBlocksResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ChainProposedBlocksResponse
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof ChainProposedBlocksResponse
     */
    maxPage?: number;
    /**
     * 
     * @type {number}
     * @memberof ChainProposedBlocksResponse
     */
    totalSize?: number;
}

export function ChainProposedBlocksResponseFromJSON(json: any): ChainProposedBlocksResponse {
    return ChainProposedBlocksResponseFromJSONTyped(json, false);
}

export function ChainProposedBlocksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChainProposedBlocksResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ChainBlockInfoFromJSON)),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'maxPage': !exists(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !exists(json, 'totalSize') ? undefined : json['totalSize'],
    };
}

export function ChainProposedBlocksResponseToJSON(value?: ChainProposedBlocksResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ChainBlockInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize,
    };
}


